import * as React from 'react';

import { rgba } from 'polished';
import styled, { css } from 'styled-components';

import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import { Translate } from 'react-localize-redux';
import AppState from '../../../store/state';
import { connect } from 'react-redux';

interface DowngradePlanCardProps {
  className?: string;
  title: string;
  isNewPlan: boolean;
}

interface StateProps {
  features: string[];
}

const mapStateToProps = (state: AppState, props: DowngradePlanCardProps) => ({
  features:
    state.products.list.find(
      (p) => p.category === 'PLAN' && p.name === props.title
    )?.features || [],
});

const DowngradePlanCard: React.FC<DowngradePlanCardProps & StateProps> = (
  props
) => {
  return (
    <StyledBox
      className={`${props.className || ''}`}
      isNewPlan={props.isNewPlan}
    >
      <Flex className="wrapper" alignItems="flex-start">
        <TitleWrapper>
          <Typography className="mb-5" weight="700">
            {props.title}
          </Typography>
          <PositionedType type="small" weight="700" isNewPlan={props.isNewPlan}>
            <Translate
              id={
                props.isNewPlan
                  ? 'ONBOARDING.DOWNGRADE.PLAN.NEW'
                  : 'ONBOARDING.DOWNGRADE.PLAN.CURRENT'
              }
            />
          </PositionedType>
        </TitleWrapper>
        <InfoWrapper>
          {props.features.map((feature, i) => (
            <Item key={i}>{feature}</Item>
          ))}
        </InfoWrapper>
      </Flex>
    </StyledBox>
  );
};

export default connect(mapStateToProps)(styled(DowngradePlanCard)`
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`);

const StyledBox = styled(Box)<{ isNewPlan: boolean }>`
  .wrapper {
    justify-content: flex-start;
    @media ${({ theme }) => theme.device.tablet} {
      justify-content: space-between;
    }
  }
  ${({ isNewPlan }) =>
    !isNewPlan
      ? css`
          background-color: ${({ theme }) => theme.colors.menuBackground};
          user-select: none;

          /* .wrapper {
            > div {
              & > span {
                color: ${({ theme }) => theme.colors.primary};
                opacity: 0.5;
              }
              > div {
                & > span {
                  color: ${({ theme }) => theme.colors.primary};
                  opacity: 0.5;
                }
              }
            }
          } */
        `
      : null}
`;

const TitleWrapper = styled.div`
  position: relative;
  width: 110px;
  @media ${({ theme }) => theme.device.tablet} {
    width: auto;
  }
`;

const InfoWrapper = styled.div``;

const PositionedType = styled(Typography)<{ isNewPlan?: boolean }>`
  border-radius: 90px;
  background-color: ${({ theme }) => rgba(theme.colors.success, 0.3)};
  color: ${({ theme }) => theme.colors.success} !important;
  padding: 4px 8px;
  max-width: 90px;
  transform: translate(-8px, 0);
  opacity: 1 !important;
  text-align: center;
  ${({ isNewPlan }) =>
    isNewPlan
      ? css`
          background-color: ${({ theme }) => theme.colors.hint};
          color: ${({ theme }) => theme.colors.hintText} !important;
        `
      : undefined}
`;

const Item = styled(Typography)`
  margin-bottom: 10px;
  font-size: ${({ theme }) => theme.typography.span};

  @media ${({ theme }) => theme.device.tablet} {
    font-size: ${({ theme }) => theme.typography.h4};
  }

  &:last-child {
    margin-bottom: 0%;
  }
`;
